import {
  FancyList,
  PrimaryCta,
  SectionTitle,
  VideoPlayer,
} from '@sleepstation/components'
import {
  CopyLink,
  CopyParagraph,
  CopyTitlePrimary,
} from '@sleepstation/components-copy'
import { VIDEO_PROVIDERS } from '@sleepstation/const'
import { defaultDarkerTheme } from '@sleepstation/themes-public-site'
import React from 'react'
import { useLoaderData } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import PortalPage from '../pages/PortalPage'
import ConstrainedCopy from '../shared/ConstrainedCopy'
import SimpleImageAndTitle from '../shared/SimpleImageAndTitle'
import BreakoutModuleNarrow from '../shared/breakoutModules/BreakoutModuleNarrow/BreakoutModuleNarrow'
import BreakoutModuleWide from '../shared/breakoutModules/BreakoutModuleWide'
import StarscapeCallToActionBreakoutModule from '../shared/breakoutModules/StarscapeCallToActionBreakoutModule'
import TestimonialsSimple from '../shared/testimonials/TestimonialsSimple'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const PortalExpertGuidanceModule = () => {
  const data = useLoaderData()
  const {
    portal,
    page: { content },
  } = data

  return (
    <PortalPage data={data} footerMargin={0} showFooter={false}>
      <ConstrainedCopy>
        <BreakoutModuleNarrow
          hasGradient
          hasBottomBorder
          marginV={[[2, 0]]}
          paddingV={[0, [0, 1.5]]}
        >
          <SimpleImageAndTitle {...content.intro} TitleComponent={SectionTitle}>
            <CopyParagraph>
              The Sleepstation portal is here to answer your questions about
              sleep, enable you to better understand the challenges you face and
              give you a glimpse of the type of information that we can provide.
            </CopyParagraph>
            <CopyParagraph>
              By now you know your way around our portal: you’ve read some of
              our articles, taken part in a few sleep questionnaires and gained
              a better overall picture of your sleep. .
            </CopyParagraph>
            <CopyParagraph>
              But did you know we can do even more to help you achieve better
              sleep? With personalised support and guidance from our expert
              sleep team, you could be sleeping better within weeks - and the
              cost is already covered for you by {portal.fullName}.
            </CopyParagraph>
          </SimpleImageAndTitle>
        </BreakoutModuleNarrow>
        <BreakoutModuleNarrow
          hasGradient
          hasBottomBorder
          marginV={[[2, 0]]}
          paddingV={[0, [0, 1.5]]}
        >
          <SimpleImageAndTitle
            {...content.therapySummary}
            TitleComponent={SectionTitle}
          >
            <CopyParagraph>
              The main difference is the support that’s provided. When you
              register on the sleep improvement programme, you’ll have access to
              our team of sleep coaches and sleep experts who will take the time
              to understand what’s going wrong with your sleep and advise you
              how to improve it.
            </CopyParagraph>
            <CopyParagraph>
              The programme is delivered entirely online and clinically proven
              to combat even the most severe insomnia. We can help you to sleep
              better without pills and teach you how to control your sleep and
              manage your routine.
            </CopyParagraph>
            <CopyParagraph>
              When you register, you’ll have access to the most effective
              treatment available for insomnia - the gold standard approach.
              It’s called CBTi and we use it to help people.
            </CopyParagraph>
            <FancyList {...content.benefitsList} />
            <CopyParagraph>
              We’ll look at your lifestyle and the problems you might face
              before tailoring a personalised sleep programme to meet your
              individual needs and circumstances.
            </CopyParagraph>
            <CopyParagraph>
              So if your dream is to sleep soundly night after night then
              there’s never been a better time to make it happen.
            </CopyParagraph>
            <CopyParagraph>
              Access to our sleep improvement programme is available now and for
              free.
            </CopyParagraph>
            {/* eslint-disable-next-line jsx-a11y/iframe-has-title  */}
            <VideoPlayer
              {...content.videoPlayer}
              provider={VIDEO_PROVIDERS.VIMEO}
              aspectRatio={16 / 9}
              useAspectWrapper
            />
          </SimpleImageAndTitle>
        </BreakoutModuleNarrow>
        <CopyTitlePrimary>
          Register now and meet your support team
        </CopyTitlePrimary>
        <CopyParagraph>
          You’ve used our portal. We’ve told you all about our sleep improvement
          programme. And right now it’s a service we can offer you free of
          charge.
        </CopyParagraph>
        <CopyParagraph>
          So don’t sleep on it.{` `}
          <CopyLink href={portal.helpers.getLicenceSignupPath()}>
            Register for free access and start today
          </CopyLink>
          .
        </CopyParagraph>
        <br />
        <br />
        <ThemeProvider theme={defaultDarkerTheme}>
          <StarscapeCallToActionBreakoutModule>
            <PrimaryCta {...content.cta1} forceOpenInNewWindow />
          </StarscapeCallToActionBreakoutModule>
        </ThemeProvider>
        <BreakoutModuleWide paddingV={[[2, 2]]}>
          <TestimonialsSimple {...content.simpleTestimonials} />
        </BreakoutModuleWide>
        <ThemeProvider theme={defaultDarkerTheme}>
          <StarscapeCallToActionBreakoutModule showBottomBorder={false}>
            <PrimaryCta {...content.cta2} forceOpenInNewWindow />
          </StarscapeCallToActionBreakoutModule>
        </ThemeProvider>
      </ConstrainedCopy>
    </PortalPage>
  )
}

export default PortalExpertGuidanceModule
